<div class="main-container" id="container">
  <div class="prueba"></div>
  <!-- Logo area (Larger Screen) Starts -->
  <!-- Logo area (Larger Screen) Ends -->
  <div class="overlay"></div>
  <div class="search-overlay"></div>
  <div class="rightbar-overlay"></div>

  <aside app-sidebar></aside>
  <div id="content" class="main-content">
    <nav app-header></nav>
    <router-outlet></router-outlet>
  </div>
  <footer app-footer></footer>
</div>